$mol_icon_drag_horizontal_variant $mol_icon path \M21 11H3V9H21V11M21 13H3V15H21V13Z
